import React, { Component } from 'react';
import { vidisLogin } from '../config';
import { VidisButtonContainer } from './StyledElements';
import VidisLogo from '../assets/icons/VidisLogoNoText.svg';
import VidisLogoInverted from '../assets/icons/VidisLogoNoTextInverted.svg';
import styled from 'styled-components';
import { placeholder } from 'lodash/fp/sortBy';

const SytledPlaceholder = styled.div`
  color: #0000c4;
  background: #d2eeff;
  background-color: #d2eeff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-style: normal;
  transition: none;
  padding: 16px 24px;
  fill: #0000c4;
  height: 40px;
  width: 100%;
  font-family: "Barlow";
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0;
  cursor: pointer;
  user-select: none;
  align-items: center;
  vertical-align: bottom;
  overflow: hidden;
  position: relative;
  padding-left: 16px;
  display: inline-flex;
  cursor: wait;

  .logo-normal {
    display: inline-flex;
  }

  .logo-inverted {
    display: none;
  }

  &:hover {
    background: #0000c4;
    color: #d2eeff;
    fill: #d2eeff;

    .logo-normal {
      display: none;
    }

    .logo-inverted {
      display: inline-flex;
    }
  }

  .entry-button-label {
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-left: 0.5rem;
    font-weight: 600;
  }

  .logo {
    width: 1.5rem;
  }
`;

const VidisButtonPlaceholder = ({onClick}) => {
  return (
    <SytledPlaceholder onClick={onClick} aria-label="Anmelden mit VIDIS" alt="Anmelden mit VIDIS">
      <img alt="logo" src={VidisLogo} class="logo logo-normal" />
      <img alt="logo" src={VidisLogoInverted} class="logo logo-inverted" />
      <span class="entry-button-label">Anmelden mit VIDIS</span>
    </SytledPlaceholder>
  );
}

class VidisLoginButton extends Component {
  state = {
    placeholderVisible: true,
    placeholderClicked: false,
  };

  vidisScriptHasLoaded = () => {
    this.setState({ placeholderVisible: false });
    if (this.state.placeholderClicked) {
      // Forwarding event after load
      window.setTimeout(() => {
        document.querySelector('vidis-login').shadowRoot.querySelector('button').click()
      }, 200);
      this.setState({ placeholderClicked: false });
    }
  };

  placeholderClick = () => {
    this.setState({ placeholderClicked: true });
  };

  componentDidMount() {
    if (!vidisLogin || !vidisLogin.url || !vidisLogin.url.length) return;

    const script = document.createElement("script");
    script.src = "https://repo.vidis.schule/repository/vidis-cdn/latest/vidisLogin.umd.js";

    if (!customElements.get('vidis-login')) {
      document.body.appendChild(script);
    } else {
      // Breaks otherwise when elemt is defined
      window.location.reload();
    }

    script.onload = this.vidisScriptHasLoaded;
  }

  render () {
    return (
      <VidisButtonContainer>
        <vidis-login size="s" cookie="false" loginurl={vidisLogin.url}></vidis-login>
        {this.state.placeholderVisible && <VidisButtonPlaceholder onClick={this.placeholderClick}></VidisButtonPlaceholder>}
      </VidisButtonContainer>
    );
  }
};

export default VidisLoginButton;
